/// <amd-module name="Repos/VersionDialogs/Components/Delete/DeleteDialog" />
import * as React from "react";

import { MessageDialog } from "VSS/Features/PlatformUI/MessageDialog";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import { Observer } from "VSSUI/Observer";

import * as Resources from "Repos/VersionDialogs/Resources";

import { DialogResult } from "../../VersionDialogsService";
import { IDeleteDialogProps } from "./DeleteDialog.Props";

export class DeleteDialog extends React.Component<IDeleteDialogProps> {
    public render(): JSX.Element {
        const { deleteMessage, deleteResult, dialogTitle, onDeleteComplete } = this.props;
        return (
            <Observer deleteResult={deleteResult}>
                {(props: { deleteResult: DialogResult }) => {
                    let inProgress: boolean | undefined;
                    if (props.deleteResult) {
                        if (props.deleteResult.item) {
                            // We still want to keep buttons disabled until dialog is disposed
                            inProgress = true;
                        } else {
                            inProgress = props.deleteResult.inProgress;
                        }
                    }

                    const contentProps: IDeleteDialogContentProps = {
                        deleteMessage,
                        deleteResult: props.deleteResult,
                        onDeleteComplete
                    };

                    return (
                        <MessageDialog
                            cancelButtonProps={{
                                disabled: inProgress,
                                text: Resources.CancelButtonText
                            }}
                            lightDismiss={false}
                            message={<DeleteDialogContent {...contentProps} />}
                            okButtonProps={{
                                disabled: inProgress,
                                text: Resources.DeleteButtonText
                            }}
                            onClose={this.onClose}
                            title={dialogTitle}
                        />
                    );
                }}
            </Observer>
        );
    }

    private onClose = (result: boolean): void => {
        const { onDeleteClick, onDismiss } = this.props;
        if (result) {
            onDeleteClick();
        } else {
            onDismiss();
        }
    };
}

interface IDeleteDialogContentProps {
    deleteResult: DialogResult;
    deleteMessage: string;
    error?: Error;
    onDeleteComplete: (item: any) => void;
}

const DeleteDialogContent = (props: IDeleteDialogContentProps) => {
    const { deleteMessage, deleteResult, onDeleteComplete } = props;

    React.useEffect(() => {
        if (deleteResult.item) {
            onDeleteComplete(deleteResult.item);
        }
    });

    const { error } = deleteResult;

    return (
        <div className="rhythm-vertical-16 flex-grow">
            {error && <MessageCard severity={MessageCardSeverity.Error}>{error.message}</MessageCard>}
            <div>{deleteMessage}</div>
        </div>
    );
};
